<script>
	export let selected = 0;
</script>

{#if selected !== "outro"}
	<div class="count">
		<span class="selected">{selected + 1}</span>
		<span class="of">OF</span>
		<span class="ten">10</span>
	</div>
{/if}

<style>
	.count {
		height: calc(var(--height) * 0.1);
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(2, 1fr);
		grid-column-gap: 0px;
		grid-row-gap: 0px;
		align-items: center;
		justify-items: center;
		width: 4rem;
		margin: 0 auto;
		line-height: 1em;
	}
	.selected {
		grid-area: 1 / 1 / 3 / 2;
		font-size: 2.5rem;
		color: var(--accent);
		justify-self: end;
	}
	.of {
		grid-area: 1 / 2 / 2 / 3;
		align-self: flex-end;
	}
	.ten {
		grid-area: 2 / 2 / 3 / 3;
		align-self: flex-start;
	}
</style>
